import { render, staticRenderFns } from "./HomeInfoAbatedor2.vue?vue&type=template&id=14210392&"
import script from "./HomeInfoAbatedor2.vue?vue&type=script&lang=js&"
export * from "./HomeInfoAbatedor2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports